import { Box, Container } from "@mui/material";
import { grey } from "@mui/material/colors";
import * as Sentry from "@sentry/react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Image from "next/image";
import { useEffect } from "react";

import { Footer } from "../src";
import { AuthForm } from "../src/account/AuthForm";
import { getRawLayout } from "../src/layouts/RawLayout";
import { routerSafePush } from "../src/navigation/routerSafePush";
import { routeHome } from "../src/routes";

import { NextPageWithLayout } from "./_app";

const SignIn: NextPageWithLayout = () => {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
      if (user != null) {
        Sentry.setUser({ id: user.uid });
        routerSafePush(routeHome());
      } else {
        Sentry.configureScope((scope) => scope.setUser(null));
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: grey[50],
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <>
        <Container
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box
            py={4}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{ minWidth: { xs: "38ch", md: "50ch" }, maxWidth: "50%" }}
              >
                <Box sx={{ textAlign: "center" }} mb={2}>
                  <Image
                    src="/logo-mick.webp"
                    height={45}
                    width={90}
                    alt="Logo Mick by Promis"
                  />
                </Box>
                <AuthForm initialMode="LOGIN" />
              </Box>
            </Box>
            <Box display={{ xs: "none", md: "block" }}>
              <Image
                src="/scene.svg"
                width={500}
                height={390}
                alt="mick-connection"
                priority={true}
              />
            </Box>
          </Box>
        </Container>
        <Container>
          <Footer />
        </Container>
      </>
    </Box>
  );
};

export default SignIn;

SignIn.getLayout = getRawLayout;
